<template>
  <div class="content">
    <div class="c_position">
      <span class="el-icon-location-outline"></span>
      <label>你现在的位置：</label>
      <label><span @click="routerNav()">首页</span>><span>行业信息</span>><span>{{pos}}</span></label>
    </div>
    <div class="profile">
      <div class="p_left">
        <div style="cursor:auto">行业信息</div>
        <div
          v-for="(item,index) in list"
          :key="index"
          @click="ptext(index)"
          :class="statuNum == 0 && selfnum==index?'change':'normal'"
        >
          <label>{{item.label}}</label>
        </div>
        <!-- <div @click="ptext(1)" :class="statuNum == 0 && selfnum==1?'change':'normal'">
          <label>行业探讨</label>
        </div>
        <div @click="ptext(2)" :class="statuNum == 0 && selfnum==2?'change':'normal'">
          <label>政策法规</label>
        </div>-->
      </div>
      <div class="p_right">
        <div class="p_type">{{pos}}</div>
        <div class="p_text">
          <div class="c_mes c_mes2">
            <ul>
              <li v-for="(item,index) in listChild" :key="index">
                <!-- <span class="icon_top" v-if="item.isTop==1">置顶</span> -->
                <span class="first_text" @click="jump(item)">{{item.title|dataShow}}</span>
                <span class="c_date">{{item.createTime|dataFormat}}</span>
              </li>
            </ul>
          </div>
          <div class="block">
            <el-pagination
              background
              :current-page.sync="pageNum"
              @current-change="handleSizeChange"
              
              layout=" prev, pager, next, total, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit: 9,
      pageNum: 1,
      total: 0,
      statuNum: 0,
      selfnum: 0,
      poslist: ["行业新闻", "行业探讨", "政策法规"],
      pos: "政策法规",
      list: [],
      listChild: [],

      ptextNum:this.$route.query.num
    };
  },
  filters: {
    dataFormat(msg) {
      var rs = msg.slice(0, 10);
      return rs;
    },
    dataShow(msg) {
      if (msg.length >= 40) {
        var res = msg.slice(0, 40) + "...";
        return res;
      } else {
        return msg;
      }
    }
  },
  methods: {
      routerNav(){
      this.$router.push({ path: "/home" });
    },
    req(i) {
      // console.log(i);
      //2
      // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
      this.$axios({
        method: "GET",
        url: "/tourist/findArticalList",
        params: {
          columnId: this.list[i].value,
          pageNum: this.pageNum,
          limit: this.limit,
          type: "1",
        },
      }).then((respone) => {
        // console.log(respone.data.data);
        this.total = respone.data.data.total; //改 获取的总条数
        this.listChild = respone.data.data.list;
        // this.pageNum = respone.data.data.pageNum;
        // this.pageNum = 1
      });
      //2
    },
    ptext(num) {
      this.pageNum = 1
      // console.log(num,'num2');
      this.req(num);
      this.selfnum = num;
      this.pos = this.list[num].label;
      if (this.list[num].articalList != null) {
        this.listChild = this.list[num].articalList;
      } else {
        this.listChild = [];
      }
    },
    handleSizeChange(page) {
      this.pageNum = page;
      this.req(this.selfnum);
    },
    pre() {
      this.pageNum -= 1;
      this.req(this.selfnum);
    },
    nex() {
      this.pageNum += 1;
      this.req(this.selfnum);
    },
    jump(data) {
      // console.log(data,'data');
      
      this.$router.push({
        path: "/ContentDetails",
        query: { pos1: "行业信息", pos2: "详情", pos3:data.jointNames.split('/')[1],data:data.id},
      });
    },
  },
  created(){
    
    // console.log(this.$route.query.num,'this.$route.params.num');
  },
  mounted() {
    // debugger
    // this.pageNum = 1
    // let me = this;
    window['ptext'] = (num) => {
        this.ptext(num)
    }
    // this.$store.commit("ptextFn", this.ptext);
    var id = window.sessionStorage.getItem("hyxx");
    this.$axios({
      method: "GET",
      url: "/tourist/findColumnByParentIdAndMenuId",
      params: {
        parentId: id,
        menuSign: 1,
      },
    }).then((res) => {
      // console.log(res.data.data, "-----------");
      this.list = res.data.data;
      if (this.list !== []) {
        this.ptext(this.$route.query.num)
      }
      // console.log(this.$route.query.num,'this.$route.query.num');
      // console.log(res.data.data,'-----------');
      //2
      // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
      this.$axios({
        method: "GET",
        url: "/tourist/findArticalList",
        params: {
          columnId: res.data.data[this.$route.query.num].value,
          pageNum: this.pageNum,
          limit: this.limit,
          type: "1",
        },
      }).then((rest) => {
        // console.log(rest.data.data);
        this.total = rest.data.data.total; //改 获取的总条数
        this.listChild = rest.data.data.list;
        // this.pageNum = 1
        window.scrollBy(0, -1000)
      });
      //2
    });
    // console.log(this.ptextNum,'this.ptextNum');
    // if (this.list !== []) {
    //   this.ptext(this.ptextNum)
    // }
  },
};
</script>

<style lang="less" scoped>
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.profile {
  width: 1173px;
  height: 824px;
  // margin-left: 353px;
  // margin:0 20%;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  .p_left {
    width: 258px;
    height: 730px;
    border: 1px solid #f6f6f6;
    display: flex;
    flex-direction: column;
    background-color: #fdfdfd;
    div {
      width: 258px;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      label {
        margin-left: 24px;
        margin-top: 20px;
      }
      label:hover {
        cursor: pointer;
      }
    }
    div:hover {
      cursor: pointer;
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    div:nth-child(1) {
      color: white;
      text-align: center;
      font-size: 18px;
      font-weight: 1000;
      background-color: #1b7aca;
    }
    div:nth-child(1):hover {
      cursor: none;
      background-color: none;
    }
  }
  .p_right {
    height: 824px;
    width: 915px;
    .p_type {
      margin-left: 28px;
      height: 60px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      color: rgba(49, 104, 155, 1);
      font-size: 18px;
      line-height: 65px;
      font-weight: 1000;
      padding-left: 20px;
    }
    .p_text {
      margin-top: 19px;
      height: 744px;
      width: 872px;
      margin-left: 48px;
      span:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
      .c_date {
        color: #999ca1;;
        // margin-left:10px;
        margin-left: 10px;
        float: right;
        margin-right: 30px;
      }
    }
  }
  .c_mes2 {
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    width: 872px;
    height: 600px;
    border: none;
    ul {
      li {
        font-size: 16px;
        margin: 0px;
        border-bottom: 1px dashed #e9e9e9;
        height: 60px;
        padding: 0px;
        line-height: 60px;
      }
    }
    .first_text{
      &:hover{
        cursor: pointer !important;
        text-decoration: underline !important;
      }
    }
  }
}
</style>